<template>
  <span class="breadcrumbs">
    <template v-if="breadcrumbs.length">
      <template  v-for="(crumb,index) in breadcrumbs">
        <template v-if="gFilesMap[crumb.id].parents">
          <template v-if="index === 0">
            <a v-if="!isLoading" :key="'a'+index" href="#" @click.prevent.stop="onLoadBreadcrumbs">..</a>
            <template v-if="isLoading">..</template>
          </template>
          /
        </template>
        <a :key="index" :href="gFilesMap[crumb.id].webViewLink" target="_blank">{{getName(crumb, index)}}</a>

      </template>
    </template>
    <template v-else>
      <a v-if="!isLoading" href="#" @click.prevent.stop="onLoadBreadcrumbs">..</a>
      <template v-if="isLoading">..</template>
      / <a :href="gFolder.webViewLink" target="_blank">{{gFolder.name}}</a>
    </template>
  </span>
</template>
<script>
// import GFile from '@/components/GFile.vue'
import { GApiMixin } from '@/mixins/GApiMixin.js'
export default {
  name: 'BreadCrumbs',
  mixins: [GApiMixin],
  props: {
    gFolder: { type: Object, required: true },
    maxAge: { type: Number, required: true },
    autoLoad: { type: Boolean, default: false },
    autoLoadStopAtIds: { type: Array }
  },
  data () {
    return {
      breadcrumbs: [],
      isLoading: false
    }
  },
  created () {
    if (this.autoLoad) {
      this.onLoadBreadcrumbs(this.autoLoadStopAtIds)
    }
  },
  methods: {
    getName (crumb, index) {
      if (this.gFilesMap[crumb.id].name.toLowerCase() === 'review' && index === 0 && this.gFilesMap[crumb.id].description) {
        return '[' + this.gFilesMap[crumb.id].description + '] ' + this.gFilesMap[crumb.id].name
      } else {
        return this.gFilesMap[crumb.id].name
      }
    },
    onLoadBreadcrumbs (stopAtIds) {
      if (!Array.isArray(stopAtIds)) {
        stopAtIds = []
      }
      this.isLoading = true
      this.getBreadcrumbs(this.gFolder.id, stopAtIds, this.maxAge).then(crumbs => {
        this.breadcrumbs = crumbs
        this.isLoading = false
      })
    }
  }
}
</script>
